export const faqs = [
  {
    category: 'Instalación',
    question: '¿Cuánto tarda la instalación del sistema?',
    answer: 'La instalación de HIOPOS Cloud es rápida y sencilla. En la mayoría de los casos, tu negocio estará operativo en menos de 24 horas. Nuestro equipo técnico se encarga de configurar el software, el hardware táctil y los dispositivos de pago para que solo tengas que empezar a vender.',
  },
  {
    category: 'Instalación',
    question: '¿Necesito cambiar todo mi hardware actual?',
    answer: 'No. HIOPOS Cloud funciona en múltiples dispositivos: TPV táctil, tablets, smartphones e incluso tu hardware compatible actual. Evaluamos tu equipamiento y te recomendamos la solución más rentable, sin cambiar lo que ya te funciona.',
  },
  {
    category: 'Soporte técnico',
    question: '¿En cuánto tiempo responde el soporte técnico?',
    answer: 'Contestamos en menos de 24 horas. Puedes contactarnos por teléfono, email o chat en directo y nuestro equipo de soporte técnico te responde a la mayor brevedad posible, con resolución de incidencias garantizada.',
  },
  {
    category: 'Soporte técnico',
    question: '¿Qué pasa si se cae la conexión a internet?',
    answer: 'El sistema sigue funcionando. HIOPOS Cloud es un TPV híbrido que opera con o sin conexión: registra todas las ventas localmente y se sincroniza automáticamente con la nube cuando se restablece la conexión, sin perder ni un solo dato.',
  },
  {
    category: 'VeriFactu',
    question: '¿El sistema está adaptado a la normativa VeriFactu?',
    answer: 'Sí. HIOPOS Cloud cumple totalmente con la normativa VeriFactu, obligatoria antes del 1 de enero de 2027. El sistema genera y envía automáticamente las facturas simplificadas a la AEAT, sin que tengas que hacer nada manualmente.',
  },
  {
    category: 'VeriFactu',
    question: '¿Tengo que hacer algo para cumplir con Hacienda?',
    answer: 'No. La integración con VeriFactu es automática y transparente. Cada vez que emites un ticket, el sistema lo registra, firma y envía a Hacienda por ti. Solo tienes que vender; nosotros nos encargamos del cumplimiento fiscal.',
  },
  {
    category: 'Integración',
    question: '¿Puedo integrar el TPV con mi ecommerce y pedidos online?',
    answer: 'Por supuesto. El ecosistema SmartPOS es omnicanal: integra TPV, carta digital, pedidos online, delivery, takeaway y reservas en un único sistema. Todo sincronizado en tiempo real, con el stock y las ventas centralizados.',
  },
  {
    category: 'Integración',
    question: '¿Funciona con varios establecimientos?',
    answer: 'Sí. HIOPOS Cloud es multiestablecimiento y multiterminal. Gestiona todas tus tiendas desde un único panel, con el stock, las ventas y los informes consolidados en tiempo real, sin importar cuántos establecimientos tengas.',
  },
];